// Feature flags for homepage sections.
// Controlled via NEXT_PUBLIC_ENABLE_* env vars; default is enabled (true).
// Example: NEXT_PUBLIC_ENABLE_COMPANY=false
const toBoolean = (value: string | undefined, defaultValue = true): boolean => {
  if (value == null) return defaultValue;
  const v = value.trim().toLowerCase();
  if (['0', 'false', 'off', 'disabled', 'no'].includes(v)) return false;
  if (['1', 'true', 'on', 'enabled', 'yes'].includes(v)) return true;
  return defaultValue;
};

export const SECTIONS = {
  hero: toBoolean(process.env.NEXT_PUBLIC_ENABLE_HERO, true),
  roles: toBoolean(process.env.NEXT_PUBLIC_ENABLE_ROLES, true),
  features: toBoolean(process.env.NEXT_PUBLIC_ENABLE_FEATURES, true),
  platform: toBoolean(process.env.NEXT_PUBLIC_ENABLE_PLATFORM, true),
  company: toBoolean(process.env.NEXT_PUBLIC_ENABLE_COMPANY, false),
  contact: toBoolean(process.env.NEXT_PUBLIC_ENABLE_CONTACT, true),
} as const;
